(() => {
  angular.module('gm.modals')
  .factory('gmActionModal', gmActionModal);

  function gmActionModal(
    $q,
    GmyModal
  ) {
    'ngInject';

    const service = {
      show
    };

    return service;

    function show(title, filters, actions, data) {
      const deferred = $q.defer();

      GmyModal.showModal({
        templateUrl: 'modules/modals/controllers/actions-modal/actions-modal.html',
        controller: 'ActionsModalController',
        controllerAs: 'modalCtrl',
        inputs: {
          title,
          filters,
          actions,
          data
        }
      }).then((modal) => {
        modal.updated.then(undefined, undefined, (values) => {
          deferred.notify(values);
        });
        modal.closed.then((result) => {
          if (result) {
            deferred.resolve(result);
          } else {
            deferred.reject();
          }
        });
      });
      return deferred.promise;
    }
  }
})();
